import { CustomFabricImage } from '../../global-types';
import { helperSettingsConfig } from '../configs/helper-settings.configs';

/**
 * Calculates the PPI (Pixels Per Inch) of an image.
 * @param {CustomFabricImage} image - The object representing the image.
 * @returns {number | null} - The calculated PPI of the image. Returns null if the PPI can't be calculated.
 */
export const calculateImagePpi = (image: CustomFabricImage): number | null => {
  const { printerDpi, scalingFactor } = helperSettingsConfig;

  // Validate original image dimensions exist
  if (!image.width || !image.height) {
    throw new Error('Image width and height must be defined to calculate PPI');
  }

  // Get the scaled dimensions (canvas display size in pixels)
  const scaledWidth = image.getScaledWidth();
  const scaledHeight = image.getScaledHeight();

  if (!scaledWidth || !scaledHeight) {
    throw new Error('Scaled width and height must be defined to calculate PPI');
  }

  // The canvas is scaled by scalingFactor for rendering.
  // Calculate the physical print size in pixels (scaled width * scalingFactor)
  const printSizeInPixels = scaledWidth * scalingFactor;

  // Convert print size from pixels to inches using printerDpi
  const printSizeInInches = printSizeInPixels / printerDpi;

  // Calculate PPI: original pixels / print size in inches
  // This gives us the actual resolution of the source image at print size
  const imagePpi = image.width / printSizeInInches;

  return imagePpi;
};
